import React, { useCallback, useContext, useState } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import noop from '../../../../../utils/noop';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import ShareIcon from '@wix/da-ds/pkg/Icons/24x24/Share';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import { BiData } from '@wix/da-bi/pkg/events';
import DesktopShareModal from '../../../../../SharePopup/DesktopSharePopup/DesktopShareModal';
import { getDeviationResourceType } from '../../../../_helpers';
import overlayStyles from '../../../../Helper/OverlayIcons.scss';
var ShareControl = function (_a) {
    var deviation = _a.deviation, className = _a.className, buttonClassName = _a.buttonClassName, iconClassName = _a.iconClassName, textClassName = _a.textClassName, _b = _a.showMobileSharePopup, showMobileSharePopup = _b === void 0 ? noop : _b;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var _c = useState(false), sharePopupVisible = _c[0], setSharePopupVisible = _c[1];
    var onClick = useCallback(function () {
        if (isMobile) {
            showMobileSharePopup();
        }
        else {
            setSharePopupVisible(true);
        }
    }, [
        showMobileSharePopup,
        setSharePopupVisible,
        isMobile,
    ]);
    var onDismiss = useCallback(function () {
        setSharePopupVisible(false);
    }, [setSharePopupVisible]);
    return (React.createElement("div", { className: className },
        sharePopupVisible && (React.createElement(DesktopShareModal, { onRequestClose: onDismiss, deviation: deviation })),
        React.createElement(TextButton, { size: "medium", variant: "main", className: classnames(buttonClassName, overlayStyles['icon-button']), onClick: onClick, biData: BiData({
                evid: 355,
                typeid: getDeviationResourceType(deviation),
                itemid: deviation.deviationId,
                deviationid: deviation.deviationId,
            }), "data-hook": BiDataHook.DEVIATION_SHARE_BUTTON, "aria-label": t('deviationview.overlay.a11y.share') },
            React.createElement(ShareIcon, { size: IconSize.MEDIUM, withPadding: false, disableDefaultColors: true, className: classnames(overlayStyles['icon'], iconClassName) }),
            React.createElement("span", { className: textClassName }, t('actionbar.shareFromFeed')))));
};
ShareControl.displayName = 'ShareControl';
export default ShareControl;
//# sourceMappingURL=ShareControl.js.map